import { generateId } from 'src/utils/traceIdGenerations';
import { get } from './mainApi';

const leaveServiceBaseURL = process.env.REACT_APP_LEAVE_MANAGEMENT_SERVICE_V1_ENDPOINT;

export const getCelebrations = async (startDate: string, endDate: string) => {
  const traceId = generateId(9);
  const response = get(`${leaveServiceBaseURL}birthdays-and-milestones?traceId=${traceId}&startDate=${startDate}&endDate=${endDate}`);
  return response;
};

